import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { ProfileComponent } from './features/private/profile/profile.component';
import { AuthPageComponent } from './features/public/login/auth-page.component';
import { HomeComponent } from './features/public/home/home.component';
import { GamesComponent } from './features/private/games/games.component';
import { NotFoundComponent } from './features/public/not-found/not-found.component';
import { ProfileViewComponent } from './features/private/profile/profile-view/profile-view.component';
import { ProfileEditComponent } from './features/private/profile/profile-edit/profile-edit.component';
import { GameListComponent } from './features/private/games/game-list/game-list.component';
import { GameAddComponent } from './features/private/games/game-add/game-add.component';
import { GameEditComponent } from './features/private/games/game-edit/game-edit.component';
import { GameTableComponent } from './features/private/gametables/game-table.component';
import { GameTableListComponent } from './features/private/gametables/game-table-list/game-table-list.component';
import { GameTableAddComponent } from './features/private/gametables/game-table-add/game-table-add.component';
import { GameTableEditComponent } from './features/private/gametables/game-table-edit/game-table-edit.component';
import { GameTableDetailComponent } from './features/private/gametables/game-table-detail/game-table-detail.component';
import { OfflineComponent } from './features/public/offline/offline.component';
import { EventsComponent } from './features/private/events/events.component';
import { EventListComponent } from './features/private/events/event-list/event-list.component';
import { EventAddComponent } from './features/private/events/event-add/event-add.component';
import { EventEditComponent } from './features/private/events/event-edit/event-edit.component';
import { EventDetailComponent } from './features/private/events/event-detail/event-detail.component';
import { organizationPublishGuard } from './core/guards/organization-publish-guard';
import { adminGuard } from './core/guards/admin-guard';
import { RegistrationResultComponent } from './features/public/registration-result/registration-result';
import { OrganizationComponent } from './features/private/organization/organization.component';
import { OrganizationListComponent } from './features/private/organization/organization-list/organization-list.component';
import { OrganizationEditComponent } from './features/private/organization/organization-edit/organization-edit.component';
import { OrganizationDetailComponent } from './features/private/organization/organization-detail/organization-detail.component';
import { OrganizationAdminComponent } from './features/private/organization/organization-admin/organization-admin.component';
import { organizationManagerGuard } from './core/guards/organization-manager-guard';
import { Admin } from './features/private/admin/admin';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: AuthPageComponent },
  { path: 'signup', component: AuthPageComponent },
  { path: 'forgot-password', component: AuthPageComponent },
  { path: 'reset-password', component: AuthPageComponent },
  { path: 'verify-email', component: RegistrationResultComponent },
  { path: 'registration-result', component: RegistrationResultComponent },
  { path: 'logout', component: AuthPageComponent, canActivate: [authGuard] },
  { path: 'offline', component: OfflineComponent },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: ProfileViewComponent },
      { path: 'edit', component: ProfileEditComponent },
    ],
  },
  {
    path: 'games',
    component: GamesComponent,
    canActivate: [adminGuard],
    children: [
      { path: '', component: GameListComponent },
      { path: 'add', component: GameAddComponent },
      { path: 'mine', component: GameListComponent, data: { filter: 'mine' } },
      { path: 'edit/:id', component: GameEditComponent },
    ],
  },
  {
    path: 'events',
    component: EventsComponent,
    children: [
      { path: '', component: EventListComponent },
      {
        path: 'mine',
        component: EventListComponent,
        canActivate: [authGuard],
        data: { filter: 'mine' },
      },
      {
        path: 'add',
        component: EventAddComponent,
        canActivate: [authGuard, organizationPublishGuard],
        data: { publish: 'event' },
      },
      { path: 'edit/:id', component: EventEditComponent, canActivate: [authGuard] },
      { path: 'detail/:id', component: EventDetailComponent },
    ],
  },
  {
    path: 'tables',
    component: GameTableComponent,
    children: [
      { path: '', component: GameTableListComponent },
      {
        path: 'mine',
        component: GameTableListComponent,
        canActivate: [authGuard],
        data: { filter: 'mine' },
      },
      {
        path: 'add',
        component: GameTableAddComponent,
        canActivate: [authGuard, organizationPublishGuard],
        data: { publish: 'table' },
      },
      { path: 'edit/:id', component: GameTableEditComponent, canActivate: [authGuard] },
      { path: 'detail/:id', component: GameTableDetailComponent },
    ],
  },
  {
    path: 'organizations',
    component: OrganizationComponent,
    children: [
      { path: '', component: OrganizationListComponent },
      {
        path: 'mine',
        component: OrganizationListComponent,
        canActivate: [authGuard],
        data: { filter: 'mine' },
      },
      {
        path: 'manage',
        component: OrganizationAdminComponent,
        canActivate: [organizationManagerGuard],
      },
      { path: 'add', component: OrganizationEditComponent, canActivate: [authGuard] },
      { path: 'edit/:id', component: OrganizationEditComponent, canActivate: [authGuard] },
      { path: 'detail/:id', component: OrganizationDetailComponent },
    ],
  },
  {
    path: 'admin',
    component: Admin,
    canActivate: [authGuard, adminGuard],
  },
  { path: '**', component: NotFoundComponent },
];
